"use client";

import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
import { TriangleAlert } from "lucide-react";
import type { ContactNoteContent } from "@/features/contact/types/contact-page-content";
interface ContactNoteProps {
  content: ContactNoteContent;
}
export function ContactNote(t0) {
  const $ = _c(16);
  const {
    content
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 0,
      y: 12
    };
    t2 = {
      opacity: 1,
      y: 0
    };
    t3 = {
      once: true,
      margin: "-40px"
    };
    t4 = {
      duration: 0.55,
      delay: 0.2
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div aria-hidden={true} className="pointer-events-none absolute top-0 right-0 h-24 w-24 rounded-bl-[4rem] bg-amber-100/60" />;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex h-8 w-8 items-center justify-center rounded-xl bg-amber-400/20"><TriangleAlert className="h-4 w-4 text-amber-600" strokeWidth={2} /></div>;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== content.badge) {
    t7 = <div className="flex items-center gap-2">{t6}<span className="text-xs font-bold tracking-widest text-amber-600 uppercase">{content.badge}</span></div>;
    $[6] = content.badge;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== content.title) {
    t8 = <h3 className="text-base leading-snug font-semibold text-amber-900">{content.title}</h3>;
    $[8] = content.title;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== content.body) {
    t9 = <p className="text-sm leading-relaxed text-amber-800/80">{content.body}</p>;
    $[10] = content.body;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t7 || $[13] !== t8 || $[14] !== t9) {
    t10 = <motion.div initial={t1} whileInView={t2} viewport={t3} transition={t4} className="relative overflow-hidden rounded-3xl border border-amber-200/80 bg-amber-50 px-6 py-6">{t5}<div className="relative flex flex-col gap-3">{t7}{t8}{t9}</div></motion.div>;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
}